import {M_CheckBox, M_DrawerTableTextField, M_InputTextField, M_Select, M_TextArea, } from 'src/M_Components'

export const changes = (field, value, setData) => {
    setData((prev) => ({ ...prev, [field]: value }))
}

export const ShipmentChargesFormField = ({
    fields,
    index,
    data,
    setData,
    hideLabels,
    returnFunc,
    size,
    options,
    disabled,
}) => {
    const preferredWidth = size || fields.size || '250px'
    const fieldSize = '100%'

    const wrapperStyle = fields.grow
        ? { margin: '5px', flex: '1 1 80px', minWidth: 0 }
        : { margin: '5px', flex: `1 1 ${preferredWidth}`, minWidth: '120px' }

    if (fields.type === 'disabled') {
        return (
            <div style={wrapperStyle} key={index}>
                <M_InputTextField
                    size={fieldSize}
                    disabled
                    label={hideLabels ? null : fields.display}
                    value={data[fields.code] || ''}
                />
            </div>
        )
    }

    if (fields.type === 'select') {
        const selectOptions = options || fields.options || []
        const selectedOption = (data && data[fields.code] && selectOptions.find(o => o.value === data[fields.code])) || null

        if (disabled) {
            return (
                <div style={wrapperStyle} key={index}>
                    <M_InputTextField
                        size={fieldSize}
                        disabled
                        label={hideLabels ? null : fields.display}
                        value={selectedOption?.label || ''}
                    />
                </div>
            )
        }

        return (
            <div style={wrapperStyle} key={index}>
                <M_Select
                    autocomplete
                    hasNone
                    size={fieldSize}
                    label={hideLabels ? null : fields.display}
                    value={selectedOption}
                    options={selectOptions}
                    onChangeValue={(obj) => {
                        if (returnFunc) { returnFunc(data, fields, obj); return }
                        changes(fields.code, (obj && obj.value) || '', setData)
                    }}
                    required={hideLabels ? null : fields.required || false}
                    color={fields.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields.required && !data[fields.code] && 'var(--color-red)'}
                    favoritesFieldName={fields?.favoritesFieldName}
                    favoritesGroupName={fields?.favoritesGroupName}
                    favoritesIdKey={fields?.favoritesIdKey}
                    favoritesVarKey={fields?.favoritesVarKey}
                />
            </div>
        )
    }

    if (fields.type === 'foreignKey') {
        if (disabled) {
            return (
                <div style={wrapperStyle} key={index}>
                    <M_InputTextField
                        size={fieldSize}
                        disabled
                        label={hideLabels ? null : fields.display}
                        value={data[fields.code] || ''}
                    />
                </div>
            )
        }

        return (
            <div style={wrapperStyle} key={index}>
                <M_DrawerTableTextField
                    size={fieldSize}
                    tableLabel={fields.tableLabel ?? fields.entity}
                    label={hideLabels ? null : fields.display}
                    entity={fields.entity}
                    filterField={fields.filterField}
                    labelFields={fields.labelFields}
                    FILTER={fields.FILTER}
                    value={
                        data && data[fields.code]
                            ? Object.assign({}, ...fields.fields.map((obj) => ({ [obj.key]: data[obj.value] })))
                            : null
                    }
                    onSubmitValue={(obj) => {
                        if (returnFunc) { returnFunc(data, fields, obj); return }
                        fields.fields?.forEach((keyValue) => {
                            changes(keyValue.value, (obj && obj[keyValue.key]) || '', setData)
                        })
                    }}
                    required={hideLabels ? null : fields.required || false}
                    color={fields.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields.required && !data[fields.code] && 'var(--color-red)'}
                    favoritesFieldName={fields?.favoritesFieldName}
                    favoritesGroupName={fields?.favoritesGroupName}
                    favoritesIdKey={fields?.favoritesIdKey}
                    favoritesVarKey={fields?.favoritesVarKey}
                />
            </div>
        )
    }

    if (fields.type === 'number' || fields.type === 'text' || fields.type === 'date') {
        return (
            <div style={wrapperStyle} key={index}>
                <M_InputTextField
                    size={fieldSize}
                    label={hideLabels ? null : fields.display}
                    type={fields.type}
                    value={(data && data[fields.code]) || ''}
                    required={hideLabels ? null : fields.required || false}
                    color={fields.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields.required && !data[fields.code] && 'var(--color-red)'}
                    onChange={(e) => {
                        if (returnFunc) { returnFunc(data, fields, e.target.value); return }
                        changes(fields.code, e.target.value, setData)
                    }}
                    disabled={disabled}
                />
            </div>
        )
    }

    if (fields.type === 'textArea') {
        return (
            <div style={{ margin: '5px', minWidth: '50px', flexBasis: '100%' }} key={index}>
                <M_TextArea
                    size={size || '100%'}
                    rows={fields.rows || 3}
                    label={hideLabels ? null : fields.display}
                    value={data[fields.code] || ''}
                    required={hideLabels ? null : fields.required || false}
                    color={fields.required && !data[fields.code] && 'var(--color-red)'}
                    secondColor={fields.required && !data[fields.code] && 'var(--color-red)'}
                    onChange={(e) => {
                        if (returnFunc) { returnFunc(data, fields, e.target.value); return }
                        changes(fields.code, e.target.value, setData)
                    }}
                    disabled={disabled}
                />
            </div>
        )
    }

    if (fields.type === 'whitespace') {
        return <div style={{ margin: '5px', width: size || '250px' }} key={index} />
    }

    return null
}
